function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.65233 7.0529L0.497727 13.2075C0.107203 13.598 0.107203 14.2312 0.497727 14.6217L6.65233 20.7763C7.04285 21.1668 7.67601 21.1668 8.06654 20.7763L14.2211 14.6217C14.6117 14.2312 14.6117 13.598 14.2211 13.2075L8.06654 7.0529C7.67601 6.66238 7.04285 6.66238 6.65233 7.0529ZM5.20624 11.7961L7.3536 9.64871L11.6253 13.9146L9.47793 16.0619L5.20624 11.7961Z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1689 21.8747C9.62457 21.7814 9.10766 22.147 9.01437 22.6914C8.92108 23.2357 9.28673 23.7526 9.83108 23.8459L10.1689 21.8747ZM20 14C20 18.3827 16.2979 22 11.65 22V24C17.3298 24 22 19.5585 22 14H20ZM11.65 6C16.2979 6 20 9.61734 20 14H22C22 8.44154 17.3298 4 11.65 4V6ZM11.65 22C11.1438 22 10.6489 21.9569 10.1689 21.8747L9.83108 23.8459C10.4223 23.9473 11.0302 24 11.65 24V22Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 5L13 1V9L9 5Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13 1H13.5C13.5 0.797769 13.3782 0.615451 13.1913 0.53806C13.0045 0.46067 12.7894 0.503448 12.6464 0.646447L13 1ZM9 5L8.64645 4.64645C8.45118 4.84171 8.45118 5.15829 8.64645 5.35355L9 5ZM13 9L12.6464 9.35355C12.7894 9.49655 13.0045 9.53933 13.1913 9.46194C13.3782 9.38455 13.5 9.20223 13.5 9H13ZM12.6464 0.646447L8.64645 4.64645L9.35355 5.35355L13.3536 1.35355L12.6464 0.646447ZM8.64645 5.35355L12.6464 9.35355L13.3536 8.64645L9.35355 4.64645L8.64645 5.35355ZM13.5 9V1H12.5V9H13.5Z"
});

function SvgSwitchOrientation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-switch-orientation",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOrientation);
export default __webpack_public_path__ + "static/media/switch-orientation.8d545b6c.svg";
export { ForwardRef as ReactComponent };